/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Why_RoutineInputs */

const en_us2_profile_why_routine = /** @type {(inputs: Profile_Why_RoutineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decides how the week is split. When you change the days, you see the new week before applying it.`)
};

const pt_br2_profile_why_routine = /** @type {(inputs: Profile_Why_RoutineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decide a divisão da semana. Ao mudar os dias, você vê a semana nova antes de aplicar.`)
};

const es_419_profile_why_routine = /** @type {(inputs: Profile_Why_RoutineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decide cómo se divide la semana. Al cambiar los días, ves la semana nueva antes de aplicarla.`)
};

const pt_pt2_profile_why_routine = /** @type {(inputs: Profile_Why_RoutineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decide a divisão da semana. Ao mudares os dias, vês a nova semana antes de a aplicares.`)
};

const fr_fr2_profile_why_routine = /** @type {(inputs: Profile_Why_RoutineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détermine la répartition de la semaine. Quand tu changes de jours, tu vois la nouvelle semaine avant de l'appliquer.`)
};

const de_de2_profile_why_routine = /** @type {(inputs: Profile_Why_RoutineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestimmt die Aufteilung der Woche. Wenn du die Tage änderst, siehst du die neue Woche, bevor du sie übernimmst.`)
};

const it_it2_profile_why_routine = /** @type {(inputs: Profile_Why_RoutineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decide come si divide la settimana. Quando cambi i giorni, vedi la nuova settimana prima di applicarla.`)
};

/**
* | output |
* | --- |
* | "Decides how the week is split. When you change the days, you see the new week before applying it." |
*
* @param {Profile_Why_RoutineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_why_routine = /** @type {((inputs?: Profile_Why_RoutineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Why_RoutineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_why_routine(inputs)
	if (locale === "es-419") return es_419_profile_why_routine(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_why_routine(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_why_routine(inputs)
	if (locale === "de-DE") return de_de2_profile_why_routine(inputs)
	if (locale === "it-IT") return it_it2_profile_why_routine(inputs)
	return en_us2_profile_why_routine(inputs)
});
export { profile_why_routine as "profile.why_routine" }